import React, { useState } from "react";

const AccordionTable = ({ data, prompt_id, onUpdateStep }) => {
  const rows = Array.isArray(data) ? data : [];
  const [editIndex, setEditIndex] = useState(null); // Track which step is being edited
  const [editedContent, setEditedContent] = useState(""); // Track the new value of the edited content
  const [editedOptions, setEditedOptions] = useState(""); // Track editable options as comma separated text

  // Function to handle the click of the Edit button
  const handleEditClick = (index, currentContent, currentOptions = []) => {
    setEditIndex(index); // Set the current index to edit
    setEditedContent(currentContent); // Set the current step content as the initial value
    setEditedOptions(
      Array.isArray(currentOptions) ? currentOptions.join(", ") : currentOptions || ""
    );
  };

  // Function to handle when the user saves the updated step content
  const handleSaveClick = (item) => {
    const normalizedOptions = editedOptions
      .split(",")
      .map((option) => option.trim())
      .filter(Boolean);

    // Pass the updated content to the parent component
    onUpdateStep({
      ...item,
      step_content: editedContent,
      options: normalizedOptions,
      step_id: item.step_order,
      prompt_id, // Include prompt_id from props
    });
    setEditIndex(null); // Exit edit mode
  };

  return (
    <table className="min-w-full table-auto border-collapse border border-gray-300">
      <thead className="bg-gray-100">
        <tr>
          <th className="border border-gray-300 px-4 py-2">Step Order</th>
          <th className="border border-gray-300 px-4 py-2">Step Content</th>
          <th className="border border-gray-300 px-4 py-2">Options</th>
          <th className="border border-gray-300 px-4 py-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((item, index) => (
          <tr key={item.step_order}>
            <td className="border border-gray-300 px-4 py-2">{item.step_order}</td>

            {/* Check if the current row is in edit mode */}
            <td className="border border-gray-300 px-4 py-2">
              {editIndex === index ? (
                // Show input field if in edit mode
                <input
                  type="text"
                  value={editedContent}
                  onChange={(e) => setEditedContent(e.target.value)}
                  className="w-full rounded border px-2 py-1"
                />
              ) : (
                // Show the step content if not in edit mode
                item.step_content
              )}
            </td>

            <td className="border border-gray-300 px-4 py-2">
              {editIndex === index ? (
                <input
                  type="text"
                  value={editedOptions}
                  onChange={(e) => setEditedOptions(e.target.value)}
                  className="w-full rounded border px-2 py-1"
                  placeholder="yes, no"
                />
              ) : (
                <div className="flex flex-wrap gap-2">
                  {Array.isArray(item.options) && item.options.length > 0 ? (
                    item.options.map((option, optionIndex) => (
                      <span
                        key={`${item.step_order}-${optionIndex}`}
                        className="rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-700"
                      >
                        {option}
                      </span>
                    ))
                  ) : (
                    <span className="text-sm text-gray-400">-</span>
                  )}
                </div>
              )}
            </td>

            <td className="border border-gray-300 px-4 py-2">
              {editIndex === index ? (
                // Show Save button when in edit mode
                <button
                  className="text-blue-500 hover:underline"
                  onClick={() => handleSaveClick(item)}
                >
                  Save
                </button>
              ) : (
                // Show Edit button if not in edit mode
                <button
                  className="text-blue-500 hover:underline"
                  onClick={() => handleEditClick(index, item.step_content, item.options)}
                >
                  Edit
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AccordionTable;
